import { AxiosRequestConfig } from 'axios';

interface DestroyConfig extends AxiosRequestConfig {
  method: 'DELETE';
  url: `/classes/${string}`;
}

/**
 * DELETE /api/v2/classes/{id}
 */
export const destroy = (id: string): DestroyConfig => {
  return {
    method: 'DELETE',
    url: `/classes/${id}`,
  } as const;
};
